import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { ModalFooter, ModalFormSection } from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import { FileDropZone } from 'components/common/media';

import validationSchema from './validationSchema';

import styles from './instaTaskSideBarItemFiles.style';

const InstaTaskUploadDocumentForm = ({
  defaultValues = {},
  isLoading,
  onCancel,
  onSubmit,
  documentsType = [],
}) => {
  const [documents, setDocuments] = useState([]);
  const resolver = yupResolver(validationSchema);

  const methods = useForm({ defaultValues, resolver });

  const handleDocuments = (files) => {
    setDocuments([...files]);
  };

  const handleSubmit = (values) => {
    onSubmit({ ...values, documents });
  };

  const isDisabledSubmit =
    isLoading || methods.formState.isSubmitting || documents.length === 0;

  return (
    <FormProvider {...methods}>
      <form
        id="add-upload-document-form"
        onSubmit={methods.handleSubmit(handleSubmit)}
      >
        <ModalFormSection>
          <FieldV2
            isRequired
            label="Document Type"
            type="dropdown"
            control={methods.control}
            name="type"
            options={documentsType}
          />
          <FileDropZone
            previewFiles={false}
            callBack={handleDocuments}
            currentFiles={documents}
            accept={{
              'image/png': ['.png'],
              'image/jpg': ['.jpg'],
              'image/jpeg': ['.jpeg'],
              'application/pdf': ['.pdf'],
            }}
            styles={styles}
          />
        </ModalFormSection>
        <ModalFooter>
          <ButtonV2 type="button" variant="outlined" onClick={onCancel}>
            Cancel
          </ButtonV2>
          <ButtonV2
            form="add-upload-document-form"
            type="submit"
            loading={isLoading}
            disabled={isDisabledSubmit}
          >
            Save
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default InstaTaskUploadDocumentForm;
